export default __webpack_public_path__ + "static/media/ArchivesTimes_Vol4Issue1.0dbd5d8e.png";